import { render } from "./ContractList.vue?vue&type=template&id=3c893af4"
import script from "./ContractList.vue?vue&type=script&lang=ts"
export * from "./ContractList.vue?vue&type=script&lang=ts"
script.render = render

export default script